/* DS Gordijnrail Configurator — Shopify AJAX Cart integration */
(function () {
  'use strict';

  const P = window.RULLENS_PRODUCTS || {};

  const MODELS = {
    'recht':    { letter: 'A', label: 'Geen bochten',                  sides: ['A'],         bochten: 0 },
    'u-voor':   { letter: 'B', label: 'Links en rechts naar voren',    sides: ['A','B','C'], bochten: 2 },
    'u-achter': { letter: 'C', label: 'Links en rechts naar achteren', sides: ['A','B','C'], bochten: 2 },
    'r-voor':   { letter: 'D', label: 'Rechts naar voren',             sides: ['A','B'],     bochten: 1 },
    'r-achter': { letter: 'E', label: 'Rechts naar achteren',          sides: ['A','B'],     bochten: 1 },
    'l-voor':   { letter: 'F', label: 'Links naar voren',              sides: ['A','B'],     bochten: 1 },
    'l-achter': { letter: 'G', label: 'Links naar achteren',           sides: ['A','B'],     bochten: 1 },
  };

  let STEPS = ['model', 'afmetingen', 'bevestiging', 'glijders', 'eindkapjes'];

  const S = {
    kleur: Object.keys(P.rail || {})[0] || 'zwart',
    model: 'recht',
    modelGekozen: true,
    bevGekozen: false,
    glijderKeuzeGemaakt: false,
    glijderGekozen: false,
    ekGekozen: false,
    ekWil: false,
    steunVariantId: null,
    steunIsGeen: false,
    steunPrijs: 0,
    steunLabel: '',
    glijderProductIdx: 0,
    glijderType: 'ks',
    glijderVariantId: null,
    glijderPrijs: 0,
    glijderLabel: '',
    glijderOpening: null,
    ek: 2,
    confirmed: {},
  };

  const _gp = P.glijder_producten;
  if (_gp && _gp.length > 0) {
    const first = _gp[0];
    S.glijderType = first.type || 'ks';
  }

  const fmt = n => '€ ' + n.toFixed(2).replace('.', ',');
  const nl2 = n => n.toFixed(2).replace('.', ',');
  const $ = id => document.getElementById(id);
  const cartEndpoint = action => `${window.Shopify?.routes?.root || '/'}cart/${action}`;

  function isWave() {
    return S.glijderType === 'wave6' || S.glijderType === 'wave8';
  }

  function updateConditionalOptions() {
    const wave = isWave();
    const waveStopNotice = $('waveStopNotice');
    if (waveStopNotice) waveStopNotice.hidden = !wave;

    const lightItem = $('ciLichtkier');
    const lightInput = $('ckLichtkier');
    const noColorVariant = !getColorVariant(P.lichtkier)?.id;
    if (lightItem) {
      lightItem.classList.toggle('gr-ci--disabled', wave || noColorVariant);
      lightItem.dataset.tooltip = wave
        ? 'Niet beschikbaar bij Wave-glijders'
        : (noColorVariant ? 'Nog niet gekoppeld aan een Shopify-product' : '');
    }
    if (lightInput) {
      if (wave) lightInput.checked = false;
      lightInput.disabled = wave || noColorVariant;
    }
    if (wave) lightItem?.classList.remove('on');
  }

  function getColorVariant(product) {
    const aliases = { zwart: ['zwart', 'black', 'noir'], wit: ['wit', 'white', 'blanc'] };
    const wanted = aliases[S.kleur] || [S.kleur.replace(/_/g, ' ')];
    return (product?.variants || []).find(v => {
      const title = String(v.title || '').toLowerCase();
      return wanted.some(color => title.includes(color));
    }) || product?.variants?.[0] || null;
  }

  function getGliderVariant(product) {
    const variants = product?.variants || [];
    const colorMatch = getColorVariant(product);
    if (!isWave() || !S.glijderOpening) return colorMatch;
    const aliases = { zwart: ['zwart', 'black', 'noir'], wit: ['wit', 'white', 'blanc'] };
    const colors = aliases[S.kleur] || [S.kleur.replace(/_/g, ' ')];
    const directionTerms = S.glijderOpening === 'midden' ? ['midden', 'middle', 'center'] : ['links', 'rechts', 'zij', 'left', 'right', 'side'];
    return variants.find(variant => {
      const title = String(variant.title || '').toLowerCase();
      return colors.some(color => title.includes(color)) && directionTerms.some(term => title.includes(term));
    }) || colorMatch || variants[0] || null;
  }

  function createConfigurationId() {
    if (window.crypto?.randomUUID) return `rail-${window.crypto.randomUUID()}`;
    return `rail-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  /* ── ACCORDION ── */

  function openStep() {}
  function toggleStep() {}

  function confirmStep(step) {
    S.confirmed[step] = true;
    updateDots();
    updateAllSumms();
    calc();
  }

  function updateDots() {
    STEPS.forEach(step => {
      const el = document.querySelector(`[data-step="${step}"]`);
      if (!el) return;
      const dot = el.querySelector('.gr-dot');
      if (!dot) return;
      const isOpen = el.classList.contains('open');
      const isDone = S.confirmed[step];
      dot.dataset.state = isOpen ? 'active' : (isDone ? 'done' : 'default');
    });
  }

  function updateAllSumms() {
    const modelEl = $('summModel');
    if (modelEl) modelEl.textContent = MODELS[S.model].label;

    const afmEl = $('summAfmetingen');
    if (afmEl) {
      const length = getTotalLength();
      afmEl.textContent = length > 0 ? length + ' cm' : '—';
    }

    const bevEl = $('summBevestiging');
    if (bevEl) bevEl.textContent = S.bevGekozen ? (S.steunLabel || '').split('—')[0].trim() : '';

    const glEl = $('summGlijders');
    if (glEl) glEl.textContent = S.glijderGekozen ? (S.glijderLabel || '').split(' (')[0].trim() : '';

    const ekSumEl = $('summEindkapjes');
    if (ekSumEl) {
      if (!S.ekGekozen) {
        ekSumEl.textContent = '';
      } else if (!S.ekWil) {
        ekSumEl.textContent = 'Geen eindkapjes · Reeds in bezit of apart besteld';
      } else {
        const nEK = parseInt($('ekInput')?.value) || 2;
        const ckA = $('ckAssemblage')?.checked;
        ekSumEl.textContent = nEK + '× ' + (P.eindkapje?.label || 'Eindkapjes') + (ckA ? ' · Kant-en-klaar' : '');
      }
    }
  }

  /* ── SELECTORS ── */

  function getTotalLength() {
    const mc = MODELS[S.model];
    let total = 0;
    mc.sides.forEach(s => {
      const el = $('lengte' + s + 'Input');
      if (el) total += Math.max(0, parseInt(el.value) || 0);
    });
    return total;
  }

  function filterBevestigingByColor(kleur) {
    document.querySelectorAll('#mBevestiging .gr-bev-item[data-color]').forEach(function(item) {
      const c = item.dataset.color;
      item.style.display = (c === '' || c === kleur) ? '' : 'none';
    });
  }

  function updateGlijderImages(kleur) {
    const colorAliases = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] };
    const alts = colorAliases[kleur] || [kleur];
    document.querySelectorAll('.gr-bev-item[data-glidx]').forEach(function(item) {
      const idx = parseInt(item.dataset.glidx);
      const gp = (P.glijder_producten || [])[idx];
      if (!gp) return;
      const imgUrl = alts.reduce((found, a) => found || (gp.colorImages && gp.colorImages[a]), null) || gp.image;
      if (!imgUrl) return;
      const img = item.querySelector('.gr-bev-img img');
      if (img) { img.src = imgUrl; img.srcset = ''; }
    });
  }

  function setEindkapje(wantsEk, el) {
    S.ekGekozen = true;
    S.ekWil = wantsEk;
    document.querySelectorAll('#mEindkapjes .gr-bev-item').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const det = $('ekDetails');
    if (det) det.style.display = wantsEk ? '' : 'none';
    const summary = $('summEindkapjes');
    if (summary) {
      summary.textContent = wantsEk
        ? (parseInt($('ekInput')?.value) || 2) + '× ' + (P.eindkapje?.label || 'Eindkapjes')
        : 'Geen eindkapjes · Reeds in bezit of apart besteld';
    }
    closeModal('mEindkapjes');
    calc();
  }

  function setMontage(wantsMontage) {
    const ck = $('ckMontage');
    if (ck) ck.checked = wantsMontage;
    const btnJa  = $('btnMontageJa');
    const btnNee = $('btnMontageNee');
    if (btnJa)  btnJa.classList.toggle('active', wantsMontage);
    if (btnNee) btnNee.classList.toggle('active', !wantsMontage);
    const summ = $('summMontage');
    if (summ) {
      summ.textContent = wantsMontage ? 'Toegevoegd' : 'Niet toegevoegd';
      summ.classList.toggle('is-added', wantsMontage);
    }
    calc();
  }

  function updateEindkapjeImage(kleur) {
    const alts = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] }[kleur] || [kleur];
    const variants = P.eindkapje?.variants || [];
    const match = variants.find(v => { const vt = v.title.toLowerCase(); return alts.some(a => vt.includes(a)); })
      || variants[0];
    if (!match?.image) return;
    const img = document.querySelector('#mEindkapjes .gr-bev-img img');
    if (img) { img.src = match.image; img.srcset = ''; }
  }

  function setKleur(v) {
    S.kleur = v;
    document.querySelectorAll('.gr-sw').forEach(e => e.classList.remove('active'));
    const btn = document.querySelector('.gr-sw-' + v);
    if (btn) btn.classList.add('active');
    const railData = P.rail?.[v];
    if (railData?.id) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', railData.id);
      history.replaceState({}, '', url.toString());
    }
    if (railData?.image) {
      const el = $('grMainImg');
      if (el) { el.src = railData.image; el.srcset = ''; }
      window.GR_IMG_IDX = 0;
      document.querySelectorAll('.gr-thumb').forEach(t => t.classList.toggle('active', t.dataset.idx === '0'));
    }
    filterBevestigingByColor(v);
    updateGlijderImages(v);
    updateEindkapjeImage(v);
    if (S.glijderGekozen) {
      const gp = (P.glijder_producten || [])[S.glijderProductIdx];
      const variant = getGliderVariant(gp);
      if (variant) {
        S.glijderVariantId = variant.id;
        S.glijderPrijs = variant.price / 100;
      }
    }
    const activeSupport = document.querySelector('#mBevestiging .gr-bev-item.active[data-color]');
    if (S.bevGekozen && activeSupport && activeSupport.style.display === 'none') {
      S.bevGekozen = false;
      S.steunVariantId = null;
      const details = $('bevDetails'); if (details) details.style.display = 'none';
      const summary = $('summBevestiging'); if (summary) summary.textContent = 'Kies opnieuw voor deze kleur';
      activeSupport.classList.remove('active');
    }
    calc();
  }

  function setModel(v) {
    if (P.isDsRail && MODELS[v]?.bochten > 0) return;
    S.model = v;
    const mc = MODELS[v];
    document.querySelectorAll('.gr-model-card').forEach(c => c.classList.toggle('active', c.dataset.model === v));
    const summEl = $('summModel');
    if (summEl) summEl.textContent = mc.letter + ' — ' + mc.label;
    $('sideBRow').style.display = mc.sides.includes('B') ? 'flex' : 'none';
    $('sideCRow').style.display = mc.sides.includes('C') ? 'flex' : 'none';
    const ekInput = $('ekInput');
    if (ekInput && S.ekWil) ekInput.value = mc.sides.length === 3 ? 4 : 2;
    const srcCard = document.querySelector('.gr-model-card[data-model="' + v + '"]');
    const previewEl = $('modelSvgPreview');
    if (srcCard && previewEl) {
      const svg = srcCard.querySelector('svg');
      if (svg) previewEl.innerHTML = svg.outerHTML;
    }
    if (!S.modelGekozen) {
      S.modelGekozen = true;
      const ph = $('afmPlaceholder'); if (ph) ph.style.display = 'none';
      const det = $('afmDetails'); if (det) det.style.display = '';
    }
    closeModal('mModel');
    calc();
  }

  function setBevestiging(variantId, price, label, el) {
    const supportLabel = String(label || '').toLowerCase();
    if (P.isDsRail && (el?.dataset.dsIncompatible === 'true' || (supportLabel.includes('plafond') && supportLabel.includes('sleuf')))) return;
    S.steunVariantId = variantId ? parseInt(variantId) : null;
    S.steunIsGeen = !variantId && label === 'Geen bevestigingsmateriaal';
    S.steunPrijs = price || 0;
    S.steunLabel = label;
    document.querySelectorAll('#mBevestiging .gr-bev-item').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const shortLabel = label.split('—')[0].trim();
    const summEl = $('summBevestiging');
    if (summEl) summEl.textContent = shortLabel;
    if (!S.bevGekozen) {
      S.bevGekozen = true;
      const det = $('bevDetails'); if (det) det.style.display = '';
    }
    const advN = Math.ceil(getTotalLength() / 50) + 1;
    const steunenInputEl = $('steunenInput');
    if (steunenInputEl) steunenInputEl.value = advN;
    closeModal('mBevestiging');
    calc();
  }

  function setGlijderProduct(idx, el) {
    const gp = (P.glijder_producten || [])[idx];
    if (!gp) return;
    S.glijderProductIdx = idx;
    S.glijderKeuzeGemaakt = true;
    S.glijderGekozen = true;
    S.glijderType = gp.type || 'ks';
    S.glijderLabel = gp.title;
    const colorV = getColorVariant(gp);
    if (colorV) {
      S.glijderVariantId = colorV.id;
      S.glijderPrijs = colorV.price / 100;
    }
    S.glijderOpening = isWave() ? null : 'midden';
    setPills('pillsOpening', '');
    const waveOptions = $('waveOptions');
    if (waveOptions) waveOptions.hidden = !isWave();
    updateConditionalOptions();
    document.querySelectorAll('#mGlijders .gr-bev-item[data-glidx]').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const shortLabel = gp.title.split('—')[0].trim();
    const summEl = $('summGlijders');
    if (summEl) summEl.textContent = shortLabel;
    const advN = calcGlijderCount(getTotalLength() / 100);
    const glijdersInputEl = $('glijdersInput');
    if (glijdersInputEl) glijdersInputEl.value = advN;
    const advGlijdersEl = $('advGlijders');
    if (advGlijdersEl) advGlijdersEl.textContent = advN;
    const ph = $('glijderPlaceholder'); if (ph) ph.style.display = 'none';
    const det = $('glijderDetails'); if (det) det.style.display = '';
    closeModal('mGlijders');
    calc();
  }

  function setGeenGlijders(el) {
    S.glijderKeuzeGemaakt = true;
    S.glijderGekozen = false;
    S.glijderType = 'geen';
    S.glijderVariantId = null;
    S.glijderPrijs = 0;
    S.glijderLabel = 'Geen glijders';
    S.glijderOpening = null;
    setPills('pillsOpening', '');
    document.querySelectorAll('#mGlijders .gr-bev-item').forEach(item => item.classList.remove('active'));
    if (el) el.classList.add('active');
    const summEl = $('summGlijders');
    if (summEl) summEl.textContent = 'Geen glijders';
    const details = $('glijderDetails');
    if (details) details.style.display = 'none';
    const waveOptions = $('waveOptions');
    if (waveOptions) waveOptions.hidden = true;
    updateConditionalOptions();
    closeModal('mGlijders');
    calc();
  }

  function setOpening(v) {
    S.glijderOpening = v;
    const gp = (P.glijder_producten || [])[S.glijderProductIdx];
    if (gp && gp.variants) {
      const variant = getGliderVariant(gp);
      if (variant) { S.glijderVariantId = variant.id; S.glijderPrijs = variant.price / 100; }
    }
    setPills('pillsOpening', v);
    const advisedCount = calcGlijderCount(getTotalLength() / 100);
    const gliderInput = $('glijdersInput');
    if (gliderInput) gliderInput.value = advisedCount;
    updateConditionalOptions();
    calc();
  }

  function toggleExtra() {
    const sec = $('extraSection');
    const btn = $('extraToggleBtn');
    const open = sec.style.display === 'none';
    sec.style.display = open ? 'block' : 'none';
    btn.textContent = open ? 'Extra opties verbergen' : 'Extra opties toevoegen';
  }

  function setPills(id, v) {
    document.querySelectorAll('#' + id + ' .gr-pill').forEach(p => p.classList.toggle('active', p.dataset.v === v));
  }

  function adj(f, d) {
    const ids = { steunen: 'steunenInput', ek: 'ekInput', glijders: 'glijdersInput', qty: 'qtyInput', vg: 'vgInput' };
    const el = $(ids[f]);
    if (!el) return;
    el.value = Math.max(parseInt(el.min) || 0, Math.min(parseInt(el.max) || 999, (parseInt(el.value) || 0) + d));
    calc();
  }

  function syncCI(itemId, ckId) {
    $(itemId)?.classList.toggle('on', $(ckId)?.checked || false);
  }

  /* ── CALC + PRICE BREAKDOWN ── */

  function calcGlijderCount(m) {
    if (S.glijderType === 'wave6') {
      const factor = S.glijderOpening === 'midden' ? 20 : 18;
      return Math.ceil((m * factor) / 2) * 2;
    }
    if (S.glijderType === 'wave8') {
      const factor = S.glijderOpening === 'midden' ? 18 : 14;
      return Math.ceil((m * factor) / 2) * 2;
    }
    return Math.ceil(m * 12);
  }

  function calc() {
    const mc = MODELS[S.model];
    const len = getTotalLength();
    const hasLength = len > 0;
    const m = len / 100;
    const adv = Math.ceil(len / 50) + 1;

    // Update dimension display
    const meterVal = $('meterVal');
    if (meterVal) {
      meterVal.textContent = hasLength ? nl2(m) + ' m' : 'Vul de afmeting in';
      meterVal.classList.toggle('is-empty', !hasLength);
    }

    const railPrice = (P.rail?.[S.kleur]?.price || 0) / 100;
    const railP = len * railPrice;
    const nBochten = mc.bochten;
    const bochtenUnitPrice = (P.bocht?.price || 0) / 100;
    const bochtenP = nBochten * bochtenUnitPrice;
    const railPrijsEl = $('railPrijsVal');
    if (railPrijsEl) railPrijsEl.textContent = hasLength ? fmt(railP + bochtenP) : '';
    const bochtenPrijsEl = $('bochtenPrijsVal');
    if (bochtenPrijsEl) {
      bochtenPrijsEl.hidden = nBochten === 0 || !hasLength;
      bochtenPrijsEl.textContent = nBochten > 0 && hasLength
        ? 'Waarvan ' + nBochten + '× bocht à ' + fmt(bochtenUnitPrice) + ' = ' + fmt(bochtenP)
        : '';
    }

    [$('advSteunen'), $('advSteunenBev')].forEach(el => { if (el) el.textContent = adv; });

    // Verbinder warning
    const needsV = len > 700;
    $('warnVerbinder')?.classList.toggle('show', needsV);
    const verbinderItem = $('ciVerbinder');
    if (verbinderItem) verbinderItem.style.display = needsV ? 'flex' : 'none';
    if (needsV && $('ckVerbinder')) { $('ckVerbinder').checked = true; syncCI('ciVerbinder', 'ckVerbinder'); }

    const verbP = needsV && $('ckVerbinder')?.checked && P.verbinder?.price ? P.verbinder.price / 100 : 0;
    const nSteunen = parseInt($('steunenInput')?.value) || adv;
    const steunP = nSteunen * S.steunPrijs;

    const advG = calcGlijderCount(m);
    const advGlijdersEl = $('advGlijders');
    if (advGlijdersEl) advGlijdersEl.textContent = advG;
    const nG = parseInt($('glijdersInput')?.value) || advG;
    const gPPU = S.glijderPrijs || 0;
    const glijderP = nG * gPPU;
    const glijdersPEl = $('glijdersP');
    if (glijdersPEl) glijdersPEl.textContent = fmt(glijderP);

    const nEK = parseInt($('ekInput')?.value) || 2;
    const ekUnitPrice = (P.eindkapje?.price || 0) / 100;
    const ekP = S.ekWil ? nEK * ekUnitPrice : 0;

    const waveStopVariant = isWave() ? getColorVariant(P.waveEindstop) : null;
    const waveStopP = waveStopVariant ? 2 * (waveStopVariant.price / 100) : 0;

    const ckA = $('ckAssemblage')?.checked || false;
    const ckL = $('ckLichtkier')?.checked || false;
    const lichtkierVariant = getColorVariant(P.lichtkier);
    const ckM = $('ckMontage')?.checked || false;
    const montageUnitPrice = (P.montage?.price || 0) / 100;
    const qtyVal = Math.max(1, parseInt($('qtyInput')?.value) || 1);
    const montageMeters = Math.max(1, Math.ceil(m * qtyVal));
    const montP = ckM ? montageMeters * montageUnitPrice : 0;
    const travelP = ckM && P.voorrijkosten?.price ? P.voorrijkosten.price / 100 : 0;
    const montageRateEl = $('montageRate');
    if (montageRateEl) montageRateEl.textContent = montageUnitPrice ? fmt(montageUnitPrice) : 'Nog te koppelen';
    const montagePrijsEl = $('montagePrijs');
    if (montagePrijsEl) montagePrijsEl.textContent = montageUnitPrice ? fmt(montageMeters * montageUnitPrice) : '—';

    const waveAdvice = $('waveAdvice');
    if (waveAdvice && isWave()) {
      const spacing = S.glijderType === 'wave6' ? '6 cm' : '8 cm';
      const perMeter = S.glijderType === 'wave6'
        ? (S.glijderOpening === 'midden' ? 20 : 18)
        : (S.glijderOpening === 'midden' ? 18 : 14);
      waveAdvice.textContent = S.glijderOpening
        ? `Advies: ${perMeter} glijders per meter voor ${spacing} Wave, afgerond naar boven op een even aantal.`
        : 'Kies eerst hoe het gordijn sluit; daarna berekenen we het juiste even aantal glijders.';
    }

    syncCI('ciAssemblage', 'ckAssemblage');
    syncCI('ciLichtkier', 'ckLichtkier');

    // Build price breakdown rows
    const sideA = Math.max(0, parseInt($('lengteAInput')?.value) || 0);
    const sideB = mc.sides.includes('B') ? Math.max(0, parseInt($('lengteBInput')?.value) || 0) : 0;
    const sideC = mc.sides.includes('C') ? Math.max(0, parseInt($('lengteCInput')?.value) || 0) : 0;
    let railLabel = len + ' cm rail';
    if (nBochten > 0) {
      const parts = ['A: ' + sideA + ' cm'];
      if (sideB) parts.push('B: ' + sideB + ' cm');
      if (sideC) parts.push('C: ' + sideC + ' cm');
      railLabel += ' (' + parts.join(', ') + ')';
    }

    const rows = [];
    let totaal = 0;

    const addRow = (label, price) => {
      rows.push({ label, price });
      totaal += price || 0;
    };

    const setPrefix = qtyVal > 1 ? qtyVal + '× ' : '';
    if (S.modelGekozen && hasLength) addRow(setPrefix + railLabel, (railP + bochtenP) * qtyVal);
    if (S.bevGekozen)   addRow((nSteunen * qtyVal) + '× ' + S.steunLabel, steunP * qtyVal);
    if (S.glijderGekozen) addRow((nG * qtyVal) + '× Glijder (' + (S.glijderLabel || 'Glijder') + ')', glijderP * qtyVal);
    if (S.ekWil) addRow((nEK * qtyVal) + '× Eindkapje/eindstop', ekP * qtyVal);
    if (waveStopVariant) addRow((2 * qtyVal) + '× Losse Wave-eindstop', waveStopP * qtyVal);
    if (ckA && P.assemblage?.price) addRow(qtyVal + '× Assemblage', (P.assemblage.price / 100) * qtyVal);
    if ($('lichtkierPrice')) $('lichtkierPrice').textContent = lichtkierVariant ? fmt(lichtkierVariant.price / 100) : 'Nog te koppelen';
    if (ckL && lichtkierVariant?.price) addRow(qtyVal + '× Lichtkierverberger', (lichtkierVariant.price / 100) * qtyVal);
    if (verbP) addRow(qtyVal + '× Railverbinder', verbP * qtyVal);
    if (ckM) addRow('Montageservice', montP);
    if (travelP) addRow('Voorrijkosten (eenmalig)', travelP);

    const osRows = $('osRows');
    if (osRows) {
      osRows.innerHTML = rows.map(r =>
        '<div class="gr-os-row"><span class="orl">' + r.label + '</span>' +
        '<span class="orp">' + fmt(r.price) + '</span></div>'
      ).join('');
    }

    const osTotaal = $('osTotaal');
    if (osTotaal) osTotaal.textContent = totaal > 0 ? fmt(totaal) : '—';

    const osAantal = $('osAantal');
    if (osAantal) osAantal.textContent = qtyVal;
    const osLengte = $('osLengte');
    if (osLengte) osLengte.textContent = len + ' cm';
    const osModel = $('osModel');
    if (osModel) osModel.textContent = MODELS[S.model].letter + ' — ' + MODELS[S.model].label;
    const osKleur = $('osKleur');
    if (osKleur) osKleur.textContent = S.kleur.charAt(0).toUpperCase() + S.kleur.slice(1).replace(/_/g, ' ');
    const osMontage = $('osMontage');
    if (osMontage) osMontage.textContent = ckM ? 'Ja' : 'Nee';

    updateAllSumms();
  }

  /* ── GALLERY ── */

  function galleryGo(idx) {
    const imgs = window.GR_IMAGES || [];
    if (!imgs.length) return;
    idx = Math.max(0, Math.min(imgs.length - 1, idx));
    window.GR_IMG_IDX = idx;
    const el = $('grMainImg');
    if (el) { el.src = imgs[idx]; el.srcset = ''; }
    document.querySelectorAll('.gr-thumb').forEach(function(t) {
      t.classList.toggle('active', parseInt(t.dataset.idx) === idx);
    });
    const prev = $('grArrPrev');
    const next = $('grArrNext');
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === imgs.length - 1;
  }

  function galleryNav(dir) {
    galleryGo((window.GR_IMG_IDX || 0) + dir);
  }

  /* ── MODALS ── */

  function openModal(id) {
    $(id)?.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (id === 'mBevestiging') filterBevestigingByColor(S.kleur);
    if (id === 'mGlijders') updateGlijderImages(S.kleur);
    if (id === 'mEindkapjes') updateEindkapjeImage(S.kleur);
  }
  function closeModal(id) {
    $(id)?.classList.remove('open');
    document.body.style.overflow = '';
  }
  function closeOnBg(e, id) { if (e.target === $(id)) closeModal(id); }

  /* ── ADD TO CART ── */

  function validateConfiguration() {
    const errors = [];
    const mc = MODELS[S.model];
    if (P.isDsRail && mc.bochten > 0) errors.push('De DS-gordijnrail kan niet worden gebogen. Kies het rechte model of kies een KS-gordijnrail.');
    if (!P.rail?.[S.kleur]?.id) errors.push('De gekozen railkleur is nog niet correct aan een Shopify-variant gekoppeld.');
    mc.sides.forEach(side => {
      const input = $('lengte' + side + 'Input');
      const value = Number(input?.value);
      const min = Number(input?.min || 0);
      const max = Number(input?.max || Infinity);
      if (!Number.isFinite(value) || value < min || value > max) {
        errors.push(`Vul voor zijde ${side} een maat tussen ${min} en ${max} cm in.`);
      }
    });
    if (!S.bevGekozen) errors.push('Kies een bevestiging of kies bewust voor geen bevestigingsmateriaal.');
    if (S.bevGekozen && !S.steunIsGeen && !S.steunVariantId) errors.push('De gekozen bevestiging is nog niet correct aan een Shopify-variant gekoppeld.');
    if (!S.glijderKeuzeGemaakt) errors.push('Kies het gewenste type glijder of kies bewust voor geen glijders.');
    if (S.glijderGekozen && !S.glijderVariantId) errors.push('Het gekozen type glijder is nog niet correct aan een Shopify-variant gekoppeld.');
    if (isWave() && !S.glijderOpening) errors.push('Kies of uw Wavegordijn midden- of zijsluitend is.');
    const selectedGliderCount = Number($('glijdersInput')?.value);
    if (isWave() && Number.isFinite(selectedGliderCount) && selectedGliderCount % 2 !== 0) errors.push('Het aantal Wave-glijders moet even zijn.');
    if (!S.ekGekozen) errors.push('Kies eindkapjes of kies bewust voor geen eindkapjes.');
    if (S.ekGekozen && S.ekWil && !getColorVariant(P.eindkapje)?.id) errors.push('De eindkapjes zijn nog niet correct aan een Shopify-product gekoppeld.');
    if (mc.bochten > 0 && !P.bocht?.variantId) errors.push('Het bochtproduct is nog niet aan Shopify gekoppeld.');
    if (getTotalLength() > 700 && !P.verbinder?.variantId) errors.push('De verplichte railverbinder is nog niet aan Shopify gekoppeld.');
    if ($('ckAssemblage')?.checked && !P.assemblage?.variantId) errors.push('Assemblage is nog niet als Shopify-product gekoppeld.');
    if ($('ckLichtkier')?.checked && !getColorVariant(P.lichtkier)?.id) errors.push('De lichtkierverberger is voor de gekozen kleur nog niet correct aan een Shopify-variant gekoppeld.');
    if ($('ckMontage')?.checked && getTotalLength() <= 0) {
      errors.push('Voer eerst de gewenste lengte van de gordijnrail in om de montageprijs live te berekenen en weer te geven.');
    }
    if ($('ckMontage')?.checked && (!P.montage?.variantId || !P.voorrijkosten?.variantId)) {
      errors.push('De montageservice is tijdelijk niet beschikbaar. Neem contact met ons op, dan helpen wij u direct verder.');
    }
    if (isWave() && !P.waveEindstop?.variantId) errors.push('De verplichte losse Wave-eindstoppen zijn nog niet als Shopify-product gekoppeld.');

    const box = $('grFormError');
    if (box) {
      box.hidden = errors.length === 0;
      box.innerHTML = errors.length ? `<strong>Controleer uw configuratie:</strong><ul>${errors.map(e => `<li>${e}</li>`).join('')}</ul>` : '';
      if (errors.length) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return errors.length === 0;
  }

  async function addToCart() {
    const btn = $('addToCartBtn');
    if (!P.rail) { alert('Productdata niet geladen. Probeer de pagina te verversen.'); return; }
    if (!validateConfiguration()) return;

    btn.disabled = true;
    btn.textContent = 'Toevoegen…';

    const mc = MODELS[S.model];
    const len = getTotalLength();
    const m = len / 100;
    const adv = Math.ceil(len / 50) + 1;
    const nSteunen = parseInt($('steunenInput')?.value) || adv;
    const nBochten = mc.bochten;
    const nEK = parseInt($('ekInput')?.value) || 2;
    const needsV = len > 700;
    const nG = parseInt($('glijdersInput')?.value) || calcGlijderCount(m);

    const sideA = parseInt($('lengteAInput')?.value) || 0;
    const sideB = mc.sides.includes('B') ? (parseInt($('lengteBInput')?.value) || 0) : 0;
    const sideC = mc.sides.includes('C') ? (parseInt($('lengteCInput')?.value) || 0) : 0;

    const railVariantId = P.rail?.[S.kleur]?.id;
    const qty = Math.max(1, parseInt($('qtyInput')?.value) || 1);
    const configurationId = createConfigurationId();
    const configuredColor = S.kleur[0].toUpperCase() + S.kleur.slice(1).replace(/_/g, ' ');
    const sharedProps = {
      '_Configuratie ID': configurationId,
      '_Kleur': configuredColor,
    };
    const items = [];

    if (railVariantId) {
      const props = {
        ...sharedProps,
        '_Onderdeel': 'rail',
        '_Rail lengte cm': String(len),
        '_Aantal rails': String(qty),
        '_Montage gekozen': $('ckMontage')?.checked ? 'ja' : 'nee',
        '_Montage variant ID': String(P.montage?.variantId || ''),
        '_Voorrijkosten variant ID': String(P.voorrijkosten?.variantId || ''),
        'Model': mc.letter + ' — ' + mc.label,
        'Kleur': configuredColor,
        'Aantal rails': String(qty),
        'Totale lengte per rail': len + ' cm',
        'Montageservice': $('ckMontage')?.checked ? 'Ja' : 'Nee',
        'Zijde A': sideA + ' cm',
      };
      if (sideB) props['Zijde B'] = sideB + ' cm';
      if (sideC) props['Zijde C'] = sideC + ' cm';
      items.push({ id: railVariantId, quantity: len * qty, properties: props });
    }

    if (S.steunVariantId && nSteunen > 0) {
      items.push({ id: S.steunVariantId, quantity: nSteunen * qty, properties: { ...sharedProps, '_Onderdeel': 'bevestiging', 'Type': S.steunLabel } });
    }

    if (P.bocht?.variantId && nBochten > 0) {
      items.push({ id: P.bocht.variantId, quantity: nBochten * qty, properties: { ...sharedProps, '_Onderdeel': 'bocht', 'Model': mc.label } });
    }

    if (S.glijderVariantId && nG > 0) {
      const props = { ...sharedProps, '_Onderdeel': 'glijder', 'Type glijder': S.glijderLabel };
      if (isWave()) props['Sluiting gordijn'] = S.glijderOpening === 'midden' ? 'Middensluitend' : 'Links- of rechtssluitend';
      if (isWave() && S.glijderOpening === 'midden') {
        const perPackage = nG / 2;
        props['_Productie-instructie'] = qty === 1
          ? `LET OP – WAVE MIDDENSLUITING: Lever 2 afzonderlijke, even lange pakketten van ${perPackage} Wave-glijders: 1× links en 1× rechts. Niet als één lange glijderdraad leveren.`
          : `LET OP – WAVE MIDDENSLUITING: Voor elk van de ${qty} rails 2 afzonderlijke, even lange pakketten van ${perPackage} Wave-glijders leveren: 1× links en 1× rechts per rail. Niet als één lange glijderdraad leveren.`;
      }
      items.push({ id: S.glijderVariantId, quantity: nG * qty, properties: props });
    }

    if (S.ekWil && nEK > 0 && P.eindkapje) {
      const ekV = getColorVariant(P.eindkapje) || { id: P.eindkapje.variantId };
      if (ekV.id) items.push({ id: ekV.id, quantity: nEK * qty, properties: { ...sharedProps, '_Onderdeel': 'eindkap' } });
    }

    if (isWave()) {
      const waveStop = getColorVariant(P.waveEindstop);
      if (waveStop?.id) items.push({
        id: waveStop.id,
        quantity: 2 * qty,
        properties: { ...sharedProps, '_Onderdeel': 'wave-eindstop', 'Reden': '2 extra eindstoppen voor Wavegordijnen' }
      });
    }

    if (needsV && P.verbinder?.variantId && $('ckVerbinder')?.checked) {
      items.push({ id: P.verbinder.variantId, quantity: qty, properties: { ...sharedProps, '_Onderdeel': 'verbinder' } });
    }

    if ($('ckAssemblage')?.checked && P.assemblage?.variantId) {
      items.push({ id: P.assemblage.variantId, quantity: qty, properties: { ...sharedProps, '_Onderdeel': 'assemblage' } });
    }

    const lichtkierVariant = getColorVariant(P.lichtkier);
    if ($('ckLichtkier')?.checked && lichtkierVariant?.id) {
      items.push({ id: lichtkierVariant.id, quantity: qty, properties: { ...sharedProps, '_Onderdeel': 'lichtkier', 'Kleur': S.kleur.charAt(0).toUpperCase() + S.kleur.slice(1) } });
    }

    if (items.length === 0) {
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
      alert('Selecteer eerst een model en vul de afmetingen in.');
      return;
    }

    console.log('Cart items:', JSON.stringify(items, null, 2));

    try {
      const res = await fetch(cartEndpoint('add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.error('Cart error response:', errData);
        throw new Error(errData.description || errData.message || 'Cart error ' + res.status);
      }
      if (window.RullensCart?.syncServices) await window.RullensCart.syncServices();
      if (window.RullensCart?.refreshCartDrawer) {
        await window.RullensCart.refreshCartDrawer();
      } else {
        document.querySelector('cart-icon')?.classList.add('header-actions__cart-icon--has-cart');
      }
      const success = $('grSuccess');
      if (success) {
        success.hidden = false;
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
      alert('Er is iets misgegaan: ' + err.message);
    }
  }

  /* ── INIT ── */

  window.GR = {
    setKleur, setModel, setBevestiging, setGlijderProduct, setGeenGlijders, setEindkapje, setMontage,
    setOpening, adj, syncCI, openModal, closeModal, closeOnBg,
    addToCart, calc, galleryGo, galleryNav, dismissSuccess,
    toggleStep, confirmStep, resetConfigurator,
  };

  function dismissSuccess() {
    const success = $('grSuccess');
    if (success) success.hidden = true;
  }

  function resetConfigurator() {
    S.kleur = Object.keys(P.rail || {})[0] || 'zwart';
    S.model = 'recht';
    S.modelGekozen = true;
    S.bevGekozen = false;
    S.steunIsGeen = false;
    S.glijderKeuzeGemaakt = false;
    S.glijderGekozen = false;
    S.ekGekozen = false;
    S.ekWil = false;
    S.glijderOpening = null;
    S.confirmed = {};

    if ($('lengteAInput')) $('lengteAInput').value = '';
    if ($('lengteBInput')) $('lengteBInput').value = '';
    if ($('lengteCInput')) $('lengteCInput').value = '';
    if ($('qtyInput')) $('qtyInput').value = 1;
    if ($('ekInput')) $('ekInput').value = 2;
    ['ckAssemblage', 'ckLichtkier', 'ckVerbinder', 'ckMontage'].forEach(id => {
      if ($(id)) $(id).checked = id === 'ckVerbinder';
    });
    ['ciAssemblage', 'ciLichtkier', 'ciVerbinder'].forEach(id => $(id)?.classList.remove('on'));
    setMontage(false);
    setModel('recht');
    setKleur(S.kleur);

    const bevDet = $('bevDetails'); if (bevDet) bevDet.style.display = 'none';
    const glDet = $('glijderDetails'); if (glDet) glDet.style.display = 'none';
    const ekDet = $('ekDetails'); if (ekDet) ekDet.style.display = 'none';
    const bevSummary = $('summBevestiging'); if (bevSummary) bevSummary.textContent = '';
    const glSummary = $('summGlijders'); if (glSummary) glSummary.textContent = '';
    const ekSummary = $('summEindkapjes'); if (ekSummary) ekSummary.textContent = '';
    const formError = $('grFormError'); if (formError) { formError.hidden = true; formError.innerHTML = ''; }
    const success = $('grSuccess'); if (success) success.hidden = true;
    document.querySelectorAll('#mBevestiging .gr-bev-item, #mGlijders .gr-bev-item, #mEindkapjes .gr-bev-item')
      .forEach(item => item.classList.remove('active'));
    setPills('pillsOpening', '');
    const firstGlider = (P.glijder_producten || [])[0];
    if (firstGlider) {
      S.glijderProductIdx = 0;
      S.glijderType = firstGlider.type || 'ks';
      S.glijderLabel = firstGlider.title || '';
      const firstVariant = getColorVariant(firstGlider);
      S.glijderVariantId = firstVariant?.id || null;
      S.glijderPrijs = (firstVariant?.price || 0) / 100;
    }
    const waveOptions = $('waveOptions');
    if (waveOptions) waveOptions.hidden = !isWave();
    updateConditionalOptions();
    calc();
    document.querySelector('.gr-pf')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    setModel('recht');
    S.modelGekozen = true;
    const afmDet = $('afmDetails'); if (afmDet) afmDet.style.display = '';

    S.bevGekozen = false;
    const bevDet = $('bevDetails'); if (bevDet) bevDet.style.display = 'none';

    S.glijderKeuzeGemaakt = false;
    S.glijderGekozen = false;
    const glDet = $('glijderDetails'); if (glDet) glDet.style.display = 'none';

    S.ekGekozen = false;
    S.ekWil = false;
    const ekDet = $('ekDetails'); if (ekDet) ekDet.style.display = 'none';

    filterBevestigingByColor(S.kleur);
    updateGlijderImages(S.kleur);

    const assemblyInput = $('ckAssemblage');
    if (assemblyInput && !P.assemblage?.variantId) assemblyInput.disabled = true;
    const lightInput = $('ckLichtkier');
    if (lightInput && !getColorVariant(P.lichtkier)?.id) lightInput.disabled = true;
    updateConditionalOptions();

    calc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
